import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DigisubservicesService } from '../services/digisubservices.service';
import * as XLSX from 'xlsx';

@Component({

  templateUrl: './book-receipt-briefly-officer.component.html',
  styleUrl: './book-receipt-briefly-officer.component.scss'
})
export class BookReceiptBrieflyOfficerComponent {
  constructor(
    private dialogRef: MatDialogRef<BookReceiptBrieflyOfficerComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private service: DigisubservicesService,
    private cdr: ChangeDetectorRef, private fb: FormBuilder, private datePipe: DatePipe
  ) {
  }




  bookOfficierbrieflyFormBeans: any = []


  reportType: any
  startDate: any
  endDate: any
  repName: any
  offRepName: any
  advtName: any
  bookSellerName: any
  billno: any

  bookrcptregisterform = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
    repwise: new FormControl(),
    officerepwise: new FormControl(),
    issuename: new FormControl(),
    billnowise: new FormControl(),
    booksellerwise: new FormControl(),
  });
  startDate_contract: any;
  enddate_contract: any;
  bookOfficierbrieflyTotal: number = 0;
  ngOnInit(): void {

    debugger
    let repname: any = this.data['repName'];

    // Then check if it's not empty and convert to array
    if (repname != "") {
      repname = [repname]; // This puts the single value in an array
    }

    this.reportType = this.data['reportType'];
    this.startDate = this.data['startDate'] === undefined ? '' : this.data['startDate'];
    this.endDate = this.data['endDate'] === undefined ? '' : this.data['endDate'];
    this.repName = this.data['repName'];
    this.offRepName = this.data['officerepwise'];
    this.billno = this.data['billnowise'];
    this.bookSellerName = this.data['booksellerwise'];


    const req: any = {
      "rep_name": this.repName,
      "start_date": this.startDate,
      "end_date": this.endDate,
      "office_rep_name": this.offRepName,
      "book_seller_name": this.bookSellerName,
      "bill_no": this.billno
    }


    this.service.getBookOfficerBriefly1(req).subscribe((data) => {
      this.bookOfficierbrieflyFormBeans = data;
      
      this.bookOfficierbrieflyTotal = 0;

      // this.bookOfficierbrieflyTotal = 0;
      if (this.bookOfficierbrieflyFormBeans != null) {
        for (let data of this.bookOfficierbrieflyFormBeans) {
          for (let data1 of data.rep_data) {
            this.bookOfficierbrieflyTotal += parseInt(data1.select_entry_amt) || 0;

          }
        }
      }
    });



  }


  //  exportExcel(fileName: string): void {
  //     console.log('exportExcel called with:', fileName);

  //     let element = document.getElementById('print-section1');
  //     if (!element) {
  //       console.error('Element with ID print-section1 not found');
  //       return;
  //     }

  //     const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
  //     const wb: XLSX.WorkBook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  //     XLSX.writeFile(wb, fileName + '.xlsx');
  //   }


  exportExcel(fileName): void {
    console.log('Export function called with fileName:', fileName);

    let element = document.getElementById('print-section');
    console.log('Element found:', element);

    if (!element) {
      console.error('Element with ID "print-section" not found in DOM');
      return;
    }

    try {
      const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);
      console.log('Worksheet created:', ws);

      const wb: XLSX.WorkBook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

      XLSX.writeFile(wb, fileName + '.xlsx');
      console.log('File should be downloaded');
    } catch (error) {
      console.error('Error during export:', error);
    }
  }

}
